import { Link } from "react-router-dom";
import { featuredArticles } from "@/mocks/articles";

export default function LatestGuides() {
  return (
    <section className="w-full px-4 md:px-6 lg:px-10 py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-10 md:mb-14">
          <div>
            <span className="text-xs font-semibold uppercase tracking-wider text-primary-600 whitespace-nowrap">Learn More</span>
            <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950 mt-3">
              Latest Superbuy Spreadsheet Guides
            </h2>
          </div>
          <Link
            to="/article/ultimate-superbuy-spreadsheet-guide"
            className="text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap flex items-center gap-1 cursor-pointer"
          >
            View All Guides
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {featuredArticles.map((article, idx) => (
            <Link
              key={idx}
              to={`/article/${article.slug}`}
              className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200/60 hover:border-primary-200/60 transition-all duration-200 cursor-pointer"
            >
              <div className="h-40 md:h-44 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  title={article.title}
                />
              </div>
              <div className="p-4 md:p-5">
                <span className="text-xs font-medium text-primary-600 whitespace-nowrap">{article.category}</span>
                <h3 className="text-sm md:text-base font-semibold text-foreground-950 mt-1.5 mb-2 line-clamp-2 leading-snug">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed">{article.excerpt}</p>
                <div className="flex items-center gap-3 mt-3 pt-3 border-t border-background-200/60">
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{article.date}</span>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{article.readTime}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}